import './pilotassignment.css';
import { GoogleMap } from '../../../components/layout/map/GoogleMap';
import ContentGrid from '../../../components/layout/ContentGrid';

export default function PilotAssignmentMap({ pilotageId, shipId }) {
    return (
        <ContentGrid
            fullscreen={true}>
            <GoogleMap
                pilotageId={Number(pilotageId)}
                shipId={Number(shipId) }
                minZoom={5}
                showAis={true}
                showSettings={true}
                showSearch={true}
                autoUpdateSearchParams={true}
                />
        </ContentGrid>
    )
}
